<template>
  <b-row class="mt-3">
    <b-col lg="6" class="mb-4">
      <entity-summary :entity="entity"/>
    </b-col>
    <b-col class="mb-4">
      <needed-for-approval :neededDocs="neededDocs"/>
    </b-col>
    <b-col>
      <entity-documents :entity="entity" v-permission="permissionList"/>
    </b-col>
  </b-row>
</template>
<script>
import EntitySummary from '@/components/entities/EntitySummary';
import NeededForApproval from '@/components/entities/NeededForApproval';
import EntityDocuments from '@/components/entities/EntityDocuments';
import { ENTITY_DOC_READ } from '@/libs/permissions_list';

export default {
  name: 'EntityPending',
  components: {
    EntitySummary,
    NeededForApproval,
    EntityDocuments,
  },
  props: {
    entity: Object,
    neededDocs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      permissionList: [ENTITY_DOC_READ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/entities/EntityPending.vue